import React from "react";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";
import TitleGroup from "./input-group/TitleGroup";
import SubtitleGroup from "./input-group/SubtitleGroup";
import BackgroundGroup from "./input-group/BackgroundGroup";
import ButtonConfigGroup from "./input-group/ButtonConfigGroup";
import PlacementGroup from "./input-group/PlacementGroup";
import SecondaryButtonConfigGroup from "./input-group/SecondaryButtonConfigGroup";
import ContentImageGroup from "./input-group/ContentImageGroup";
import SecondarySubtitleGroup from "./input-group/SecondarySubtitleGroup";
import SocialGroup from "./input-group/SocialGroup";
import logger from '../../../../../utils/logger';

function InputWrapper() {
  const { currentStep, onNext, onBack } = useEditCtaContext();
  const isLastStep = currentStep === "placement";
  const isFirstStep = currentStep === "title";

  logger("log", "InputWrapper Rendered with step:", currentStep);

  return (
    <div
      className="flex flex-col min-h-full md:h-full font-montserrat"
      style={{
        background:
          "linear-gradient(90deg, #2B2A3C 0%, #363347 49%, #615B72 100%)",
      }}
    >
      {/* Header */}
      <div className="flex justify-center items-center px-3 md:px-3.5 py-2 md:py-2.5 bg-[#231E1F]">
        <h1 className="text-white text-sm md:text-base font-medium tracking-normal">
          EDIT YOUR ELEMENT
        </h1>
      </div>
      {/* Scrollable content area */}
      <div className="flex-1 overflow-y-auto">
        {currentStep === "title" && <TitleGroup />}
        {currentStep === "subtitle" && <SubtitleGroup />}
        {currentStep === "background" && <BackgroundGroup />}
        {currentStep === "button" && <ButtonConfigGroup />}
        {currentStep === "secondaryButton" && <SecondaryButtonConfigGroup />}
        {currentStep === "secondarySubtitle" && <SecondarySubtitleGroup />}
        {currentStep === "contentImageOne" && <ContentImageGroup />}
        {currentStep === "fiveButtons" && <SocialGroup />}
        {currentStep === "placement" && <PlacementGroup />}
      </div>
      {/* Footer with NEXT Button - Fixed at bottom */}
      <div className="flex justify-between items-center px-3 md:px-4 py-2 md:py-2.5 bg-[#231E1F]">
        {!isFirstStep && (
          <button
            onClick={onBack}
            className="flex items-center gap-2 md:gap-4 text-white text-xs font-medium leading-4 hover:opacity-80 transition-opacity"
          >
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path
                d="M6 11.0359L0.77991 5.80591L6 0.585938"
                stroke="white"
                strokeWidth="0.53"
                strokeLinecap="round"
              />
            </svg>
            <span>BACK</span>
          </button>
        )}
        {isFirstStep && <div></div>}
        {!isLastStep && (
          <button
            onClick={onNext}
            className="flex items-center gap-2 md:gap-4 text-white text-xs font-medium leading-4 hover:opacity-80 transition-opacity"
          >
            <span>NEXT</span>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path
                d="M1 0.585938L6.22009 5.80591L1 11.0359"
                stroke="white"
                strokeWidth="0.53"
                strokeLinecap="round"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}

export default InputWrapper;
